import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    title: "Home",
    path: "/",
    newTab: false,
  },
  {
    id: 2,
    title: "About",
    path: "/about",
    newTab: false,
  },
  {
    id: 3,
    title: "Services",
    path: "/services",
    newTab: false,
  },
  {
    id: 4,
    title: "Why Us",
    path: "/why-us",
    newTab: false,
  },
  {
    id: 5,
    title: "Careers",
    path: "/careers",
    newTab: false,
  },
  {
    id: 6,
    title: "Contact",
    path: "/contact",
    newTab: false,
  },
  // {
  //   id: 7,
  //   title: "Service",
  //   newTab: false,
  //   submenu: [
  //     {
  //       id: 41,
  //       title: "Intellectual Property",
  //       path: "/contact",
  //       newTab: false,
  //     },
  //     {
  //       id: 42,
  //       title: "Corporate Law",
  //       path: "/contact",
  //       newTab: false,
  //     },
  //     {
  //       id: 43,
  //       title: "Startup Help",
  //       path: "/contact",
  //       newTab: false,
  //     },
  //     {
  //       id: 44,
  //       title: "Litigation",
  //       path: "/contact",
  //       newTab: false,
  //     },
      
  //   ],
  // },
];
export default menuData;
